module.exports = __webpack_public_path__ + "static/media/heartcatchprecure.0fd4adb6.jpg";